@if (permission && app.unlockedId == null) {
  <button
    class="btn btn-edit btn-sm"
    [ngClass]="{ 'btn-edit': hasText }"
    (click)="edit()"
    >
    <i class="fa fa-edit">&nbsp;&nbsp;</i>
    @if (hasText) {
      <span>{{ app.text.app.edit }}</span>
    }
  </button>
}

@if (app.unlockedId === id) {
  <ng-content></ng-content>
}
